import constants from 'constants/index'

const isProjectLocked = (status) => {
  const { COMPLETED_STATUS_ID, ARCHIVED_STATUS_ID } =
    constants.governanceProject

  return [COMPLETED_STATUS_ID, ARCHIVED_STATUS_ID].includes(status)
}

export default isProjectLocked
